export const getPropsFromDataset = (element?: HTMLElement | null) => ({
  availability: element?.dataset.productAvailability,
  podType: element?.dataset.productPodType,
});
